export enum ExposureTypicality {
    Typical = 0,
    AtypicallyHigh = 1,
    AtypicallyLow = 2,
}